import React, { useEffect, useState } from "react";
import { Paper, InputBase, IconButton, Box } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import "./SearchBar.scss";

export default function SearchBar(props) {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setSearchValue(props?.search)
  }, [props?.search])
  
  const onSearch = (e) => {
   const newValue = e.target.value;
    setSearchValue(newValue);
    props.onSearchQuery(newValue);
  };

  return (
    <Box className="customSearchBar">
      <Paper className="customPaperRoot">
        <IconButton className="iconButton" type="button" aria-label="search">
          <SearchIcon />
        </IconButton>
        <InputBase
          onChange={(e) => {
            onSearch(e);
          }}
          className="inputBase"
          placeholder={props?.placeholder || "Search"}
          value={searchValue || ""}
        inputProps={{ "aria-label": "search google maps" }}
        />
      </Paper>
    </Box>
  );
}
